import React, { useCallback, useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import styles from './ModuleRecordRelation.module.css'
import { useTranslation } from "react-i18next";
import CrmButton from '../../../UI/Crm/CrmButton/CrmButton';
import CrmDivider from '../../../UI/Crm/CrmLayout/CrmDivider';
import CrmGrid from '../../../UI/Crm/CrmGrid/CrmGrid';
import ModuleFilterRecords from './ModuleFilterRecords';
import SubModal from '../../../UI/Crm/SubModal/SubModal';
import ModuleRecords from './ModuleRecords';
import { linkRelatedRecords, unLinkRelatedRecords } from '../../../../axios/requests/baseRecordReq'
import { Box } from '@mui/material';




const ModuleRecordRelation = ({ onCancelClicked, moduleObj, relatedToRecordId, mode, onReloadGrid, onOperationStart, onLinkClicked, onUnLinkClicked, suppressOpenNewRecord = true, relatedModuleObj, onSelectConv, OnAddToDialListClicked }) => {
    // const [showFilterRecordsModal, setFilterRecordsModal] = useState(false)
    const [t] = useTranslation('crm')
    const crmState = useSelector(state => state.crm)
    const selectedCrmModule = crmState?.selectedCrmModule
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // const filterRecordsModalToggel = useCallback(() => {
    //     setFilterRecordsModal((oldState) => !oldState)
    // }, [showFilterRecordsModal])

    const handleSelectionChanged = useCallback((rows) => {
        setSelectedRows(rows);
    }, []);

    const handleLinkClicked = async () => {
        if (onLinkClicked) onLinkClicked(selectedRows)
        if (selectedRows.length === 0) return console.log('No rows selected');

        // Show loading spinner immediately
        setIsLoading(true);

        // Trigger loading state on parent grid as well
        onOperationStart?.();

        try {
            // Perform async operations
            if (relatedToRecordId && selectedCrmModule._id && moduleObj._id) {
                const results = await Promise.all(
                    selectedRows.map(row =>
                        linkRelatedRecords(relatedToRecordId, row._id, selectedCrmModule._id, moduleObj._id)
                    )
                );
            }

            // After operations complete, close modal and reload grid
            onReloadGrid?.();
            onCancelClicked();
        } finally {
            setIsLoading(false);
        }
    };

    const handleUnlinkClicked = async () => {
        if (onUnLinkClicked) onUnLinkClicked(selectedRows)
        if (selectedRows.length === 0) return console.log('No rows selected');

        // Show loading spinner immediately
        setIsLoading(true);

        // Trigger loading state on parent grid as well
        onOperationStart?.();

        try {
            // Perform async operations
            if (relatedToRecordId && selectedCrmModule._id && moduleObj._id) {
                const results = await Promise.all(
                    selectedRows.map(row =>
                        unLinkRelatedRecords(relatedToRecordId, row._id, selectedCrmModule._id, moduleObj._id)
                    )
                );
            }

            // After operations complete, close modal and reload grid
            onReloadGrid?.();
            onCancelClicked();
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { // If one linked (not multiple selection)
        if (mode === 'link' && selectedRows?.length) {
            handleLinkClicked()
        }
    }, [selectedRows])

    const reloadAndClose = useCallback(() => {
        setTimeout(() => {
            onReloadGrid?.();
            onCancelClicked?.();
        }, 0)
    }, [onReloadGrid, onCancelClicked])

    return (
        <Box
            component="form"
            onSubmit={(e) => e.preventDefault()}
            noValidate
            sx={{
                p: 0,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                position: 'relative',
            }}
        >
            {/* Loading Overlay */}
            {isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000,
                        borderRadius: '10px',
                    }}
                >
                    <div style={{ textAlign: 'center' }}>
                        <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem', color: '#94a2ad' }}>
                            <span className="sr-only">Loading...</span>
                        </div>
                        <div style={{ marginTop: '12px', fontSize: '16px', color: '#94a2ad', fontWeight: 500 }}>
                            {t('Loading...')}
                        </div>
                    </div>
                </Box>
            )}

            <Box
                sx={{
                    flex: 1,
                    // overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    p: 1,
                    pr: 2 // Optional: to prevent scroll bar from overlapping content
                }}
            >
                <ModuleRecords
                    moduleObj={moduleObj}
                    multiSelectionEnable={mode !== 'link'}
                    gridTitle={moduleObj?.label}
                    gridCssClass={`${styles['records-grid']}`}
                    relatedToRecordId={relatedToRecordId}
                    relatedModuleObj={relatedModuleObj}
                    suppressOpenNewRecord={suppressOpenNewRecord}
                    suppressOpenRecord={true}
                    suppressLinkModules={true}
                    onSelectionChanged={handleSelectionChanged}
                    onNewRowAdded={reloadAndClose}
                    mode={mode}
                    onSelectConv={onSelectConv}
                    OnAddToDialListClicked={OnAddToDialListClicked}
                    useLocalFilters={true}
                />
                {/* {showFilterRecordsModal &&
                    <SubModal
                        modalTitle={t('Filter records in module X', { module: 'test' })}
                        onHide={filterRecordsModalToggel}
                    >
                        <ModuleFilterRecords moduleObj={moduleObj} onCancelClicked={filterRecordsModalToggel} />
                    </SubModal>
                } */}
            </Box>
            <CrmDivider sx={{ my: 2 }} />

            {/* Footer Buttons */}
            <Box display="flex" justifyContent="flex-end" gap={2} sx={{ pr: 2 }}>
                {/* <CrmButton variant="contained" color="primary" onClick={handleSubmit}>
                    {t('Link')}
                </CrmButton> */}
                {
                    mode === 'multilink' &&
                    <CrmButton color="crmContainedGray94" onClick={handleLinkClicked} disabled={isLoading}>
                        {t('Link')}
                    </CrmButton>
                }
                {
                    relatedToRecordId && mode === 'unlink' &&
                    <CrmButton color="crmContainedGray94" onClick={handleUnlinkClicked} disabled={isLoading}>
                        {t('Unlink')}
                    </CrmButton>
                }

                {/* {
                    relatedToRecordId && mode !== 'multilink' ?
                        <CrmButton color="crmContainedGray94" onClick={handleUnlinkClicked}>
                            {t('Unlink')}
                        </CrmButton>
                        :
                        <CrmButton color="crmContainedGray94" onClick={handleLinkClicked}>
                            {t('Link')}
                        </CrmButton>
                } */}

                {/* <CrmButton variant="outlined" color="primary" onClick={onCancelClicked}>
                    {t('Cancel')}
                </CrmButton> */}
                <CrmButton color="crmOutlinedGray94" onClick={onCancelClicked} disabled={isLoading}>
                    {t('Cancel')}
                </CrmButton>
            </Box>
        </Box>
    )
}

export default ModuleRecordRelation